import * as types from '../const/action.types';
import api from '../api/ManualProcessApi';

export function manualProcessHasErrored(bool, message) {
    return {
        type: types.MANUAl_PROCESS_HAS_ERROR,
        hasErrored: bool,
        error: message,
    };
}

export function manualProcessIsLoading(bool) {
    return {
        type: types.MANUAl_PROCESS_IS_LOADING,
        isLoading: bool,
    };
}

export function manualProcessFetchDataSuccess(items) {
    return {
        type: types.MANUAl_PROCESS_FETCH_DATA,
        items,
    };
}

export function loadManualProcesses() {
    return (dispatch) => {
        dispatch(manualProcessIsLoading(true));
        dispatch(manualProcessHasErrored(false, ''));
        return api
            .get()
            .then((response) => {
                if (response.error !== undefined) {
                    throw Error(response.message);
                }
                return response;
            })
            .then((processes) => {
                dispatch(manualProcessIsLoading(false));
                dispatch(manualProcessHasErrored(false, ''));
                dispatch(manualProcessFetchDataSuccess(processes));
            })
            .catch((error) => {
                console.error(error);
                if (error.response) {
                    dispatch(manualProcessIsLoading(false));
                    dispatch(
                        manualProcessHasErrored(error.type ? error.type : true, error.message),
                    );
                } else {
                    dispatch(manualProcessIsLoading(false));
                    dispatch(manualProcessHasErrored(false, ''));
                }
            });
    };
}



// WEBPACK FOOTER //
// ./src/actions/api.manual.process.actions.js